import { ROLES } from '@/constants/roles';
import Login from '../views/account/login.vue';
import Unauthorized from '../views/Unauthorized.vue';

import ListUsers from '@/views/users/ListUsers.vue';
import CreateUser from '@/views/users/CreateUser.vue';
import UpdateUser from '@/views/users/UpdateUser.vue';
import CompanyDetails from '@/views/companies/CompanyDetails.vue';
import LayoutWrapper from '@/components/LayoutWrapper.vue';
import ForgotPassword from '@/views/account/ForgotPassword.vue';
import ResetPassword from '@/views/account/ResetPassword.vue';
import ValidateAccount from '@/views/account/validateAccount.vue';
import ChangePassword from '@/views/account/ChangePassword.vue';
import QuestionsList from '@/views/questions/QuestionsList.vue';
import ListSurveys from '@/views/surveys/ListSurveys.vue';
import ProListSurveys from '@/views/surveys/ProListSurveys.vue';
import ListCompanies from '@/views/companies/ListCompanies.vue';

export default [
  {
    path: '/survey',
    name: 'Survey',
    component: () => import('@/views/surveys/SurveyForm.vue'),
    meta: {
      title: 'Survey',
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
    },
  },
  {
    path: '/survey/:id/edit',
    name: 'survey-edit',
    component: () => import('@/views/surveys/SurveyForm.vue'),
    props: true,
    meta: {
      title: 'Survey',
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
    },
  },
  {
    path: '/surveys/success',
    name: 'survey-success',
    component: () => import('@/views/surveys/SurveySuccess.vue'),
    meta: {
      title: 'Succès',
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot Password',
    component: ForgotPassword,
    meta: {
      title: 'Mot de passe oublié',
    },
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
    meta: {
      title: 'Réinitialiser mot de passe',
      requiresValidResetCode: true,
    },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: ChangePassword,
    meta: {
      title: 'Changer le mot de passe',
    },
  },
  {
    path: '/set-password',
    name: 'Set Password',
    component: ValidateAccount,
    meta: {
      title: 'Configurer mot de passe',
      requiresValidResetCode: true,
    },
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: Unauthorized,
    meta: {
      title: 'Accès interdit',
    },
  },
  {
    path: '/',
    component: LayoutWrapper,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/admin-dashboard/Dashboard.vue'),
        meta: {
          title: 'Tableau de Bord Global',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        // Le composeur de visualisations: un ecran a lui, sous le tableau de
        // bord dont il est le prolongement, et reserve aux memes roles.
        path: 'dashboard/visualisations',
        name: 'dashboard-visualization-report',
        component: () =>
          import('@/views/admin-dashboard/VisualizationReport.vue'),
        meta: {
          title: 'Composer une visualisation',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        path: 'pro-dashboard',
        name: 'pro-dashboard',
        component: () => import('@/views/pro-dashboard/Dashboard.vue'),
        meta: {
          title: 'Tableau de Bord Professionnel',
          roles: [ROLES.PROFESSIONAL, ROLES.SUPER_ADMIN],
        },
      },
      {
        path: 'users',
        name: 'list-users',
        component: ListUsers,
        meta: {
          title: 'Liste des utilisateurs',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        path: 'users/create',
        name: 'create-user',
        component: CreateUser,
        meta: {
          title: 'Ajouter un utilisateur',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        path: 'users/:id/edit',
        name: 'update-user',
        component: UpdateUser,
        meta: {
          title: 'Modifier un utilisateur',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        path: 'questions',
        name: 'survey-questions',
        component: QuestionsList,
        meta: {
          title: 'liste des questions',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
          bgClass: 'bg-gray',
        },
      },

      {
        path: 'companies/:id',
        name: 'company-details',
        component: CompanyDetails,
        meta: {
          title: 'Fiche Entreprise',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
        },
      },
      /*
        La comparaison de deux enquetes est une page et non une fenetre: le
        rapprochement d'un questionnaire de ~105 champs se fait defiler, se
        partage par son adresse et s'imprime. Les deux enquetes comparees sont
        dans la query afin qu'un lien rende exactement la meme comparaison.
      */
      {
        path: 'companies/:id/compare',
        name: 'company-survey-comparison',
        component: () =>
          import('@/views/companies/CompanySurveyComparison.vue'),
        meta: {
          title: 'Comparaison d’enquêtes',
          /*
            Reserve a l'administration, contrairement a la fiche entreprise
            dont la route laisse entrer un professionnel que l'API refuse
            ensuite (ADMIN-026). Ouvrir la comparaison aux memes conditions
            n'aurait fait qu'etendre ce piege a un ecran de plus.
          */
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        path: 'surveys',
        name: 'surveys',
        component: ListSurveys,
        meta: {
          title: 'liste des enquêtes',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        },
      },
      {
        path: 'professional/surveys',
        name: 'my-surveys',
        component: ProListSurveys,
        meta: {
          title: 'Mes enquêtes',
          roles: [ROLES.PROFESSIONAL],
        },
      },
      {
        path: 'companies',
        name: 'companies',
        component: ListCompanies,
        meta: {
          title: 'liste des entreprises',
          roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
        },
      },
      {
        path: '',
        name: 'dashboard-redirect',
        component: () => import('@/views/DashboardRedirect.vue'),
        meta: {
          title: 'Tableau de bord',
        },
      },
    ],
  },
];
